import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { Language, useLanguage } from "../../context/LanguageContext";

const languages = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

export const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (lang: Language) => {
    setLanguage(lang);
    setIsOpen(false);
  };

  const currentLanguage = languages.find((lang) => lang.code === language);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm 
                  bg-gray-100/80 dark:bg-gray-800/80
                  hover:bg-gray-200/80 dark:hover:bg-gray-700/80
                  transition-colors duration-200"
        aria-label="Select language"
      >
        <span className="text-base leading-none">{currentLanguage?.flag}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-gray-500 dark:text-gray-400 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <div
          className="absolute right-0 mt-1 w-32 rounded-md bg-white dark:bg-gray-800 
                    shadow-lg ring-1 ring-black/5 dark:ring-white/10
                    overflow-hidden z-10"
        >
          <div className="py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code as Language)}
                className={`flex items-center gap-2 w-full px-3 py-1.5 text-sm transition-colors
                          ${
                            language === lang.code
                              ? "bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white font-medium"
                              : "hover:bg-gray-50 dark:hover:bg-gray-700/70 text-gray-700 dark:text-gray-200"
                          }`}
              >
                <span className="text-base leading-none">{lang.flag}</span>
                <span>{lang.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
